import { IFieldInstance } from "../../types/fieldInstance.interface";

export function getFormGroups(fields: IFieldInstance[]) {
  const parentMap = new Map();
  const childMap = new Map();
  const result = [];

  // Create maps of parent and child fields
  for (const field of fields) {
    if (field.parentFieldId) {
      if (!childMap.has(field.parentFieldId)) {
        childMap.set(field.parentFieldId, []);
      }
      childMap.get(field.parentFieldId).push(field);
    } else {
      parentMap.set(field.id, [field]);
    }
  }

  // Populate parent fields with their children
  for (const [parent, children] of Array.from(childMap.entries())) {
    if (parentMap.has(parent)) {
      parentMap.get(parent).push(children);
    } else {
      children.forEach((child: IFieldInstance) => {
        const parentField = fields.find((field) => field.id === parent);
        if (!parentField) {
          parentMap.set(child.id, [child]);
        }
      });
    }
  }

  // Traverse the parent map and collect all descendants
  for (const fields of Array.from(parentMap.values())) {
    const stack = [...fields.flat()];
    const descendants = [];

    while (stack.length) {
      const field = stack.shift();
      descendants.push(field);

      if (childMap.has(field.id) && !parentMap.has(field.id)) {
        for (const child of childMap.get(field.id)) {
          stack.unshift(child);
        }
      }
    }

    result.push(descendants);
  }

  return result;
}
